import { User } from "oidc-client";
import React, {createContext, ReactNode, useReducer} from "react";
import { toast } from "react-semantic-toasts";
import { CheckboxProps, DropdownProps, InputOnChangeData, MenuItemProps, TextAreaProps } from "semantic-ui-react";
import { signInRedirectS } from "./services/UserService";
// tslint:disable-next-line: max-line-length
import {
    GLOBAL_INITIAL_STATE, OWNERSHIP_INITIAL_STATE, PortalType, State, UNDERWRITING_INITIAL_STATE,
    COVERAGE_INITIAL_STATE, EXPERIENCE_RATING_INITIAL_STATE, NOTICE_OF_ELECTION_INITIAL_STATE, PLAN_INITIAL_STATE, ACTUARIAL_INITIAL_STATE,
    MEMBERSHIP_INITIAL_STATE,
    QAPropsBase,
    HOME_INITIAL_STATE,
    stringValidatorN,
    phoneValidator,
    numberValidator,
    emailValidator,
    dateValidator,
    fileValidator,
    conditionalFileValidator,
    ownershipValidator,
    datesValidator,
    nameLocsValidator,
    pcovValidator,
    numberValidatorN,
    SPECIAL_CALLS_INITIAL_STATE,
    StatePackage,
    BasicLoadingState,
    ConditionalFileProps,
    CoverageProps
} from "./State";

type iChange = React.ChangeEvent<HTMLInputElement>;
type taChange = React.ChangeEvent<HTMLTextAreaElement>;
type sChange = React.ChangeEvent<HTMLSelectElement>;
type synEvent = React.SyntheticEvent<HTMLElement, Event>;
export type EventType = iChange | taChange | sChange | synEvent | React.SyntheticEvent<HTMLElement, Event>;
export type EventProps = DropdownProps | TextAreaProps | InputOnChangeData | CheckboxProps;
export type changeCoverageFn = (d: number) => void;
export type arrayGenerator = () => any;
export type arrayProjector = (element: any) => any;
export type dispatchFn = () => void;
// tslint:disable-next-line: max-line-length
export type changeFn = (e: iChange | taChange | sChange | synEvent, i: number, d?: DropdownProps | TextAreaProps | InputOnChangeData | CheckboxProps) => void;
export type validatorFn = (arg: any) => boolean;
export type fileListValidatorFn = (arg: FileList | null) => boolean;
export type selectChangeFn = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => void;
export type inputChangeFn = (e: React.ChangeEvent<HTMLInputElement>,
                             d: InputOnChangeData) => void;
export type textAreaChangeFn = (e: React.FormEvent<HTMLTextAreaElement>, d: TextAreaProps) => void;
export type navbarChangeFn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, d: MenuItemProps) => void;
export type entityChangeFn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, s: string, v: string) => void;
export type buttonChangeFn = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
export type genericMethod = () => void;

export const timeouts = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
];

const initialState = GLOBAL_INITIAL_STATE;
// tslint:disable-next-line: max-line-length
const store = createContext<{ state: State, dispatch: React.Dispatch<Action> }>({ state: initialState, dispatch: (v) => { return; } });
const { Provider } = store;

// tslint:disable-next-line: interface-name
export interface Action {
    type: string;
    event?: EventType;
    index?: number;
    props?: EventProps;
    value?: any;
    altValue?: any;
    validator?: validatorFn;
}

// tslint:disable-next-line: interface-name
interface Props {
  children: ReactNode;
}

function handleQAStateUpdate(source: QAPropsBase[],
                             index: number,
                             value: string,
                             validator: validatorFn): QAPropsBase[] {
  return source.map((q, idx) => {
      if (idx === index) {
          q.answerValue = value || "";
          q.isAnswered = true;
          q.isAnswerValid = validator(value || "");
      }
      return q;
  });
}

export function handleSubmit(s: StatePackage<BasicLoadingState>,
    state: State,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    shorthand: string,
    additionalPropsFn?: (formData: FormData) => void) {
    if (state.answerState != null) {
        e.preventDefault();
        s.setState({ ...s.state, isLoading: true });
        const formData = new FormData();
        state.answerState.forEach((v, i, a) => {
            formAppendHandler(formData, v.answerType, v.propName, v.answerValue);
        });
        additionalPropsFn && additionalPropsFn(formData);
        doSubmission(s, state, shorthand, formData);
    }
}

function doSubmission(s: StatePackage<BasicLoadingState>,
    state: State,
    shorthand: string,
    formData: FormData) {
    fetch(`api/${shorthand}/Submit`,
        {
            body: formData,
            method: "POST",
        })
        .then((response) => {
            if (response.ok) {
                s.setState({ ...s.state, icon: "check", isLoading: false });
                setTimeout(() => {
                    state.appState.history.push("/ThankYou");
                }, 1000);
            } else {
                fetch(`api/Error/ReportError`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(state),
                        method: "POST",
                    })
                    .then((r) => {
                        handleErrorToast(`
                            An error occurred.
                            Start a new tab and leave this page open.
                            A support representative will reach out to you soon.`);
                        s.setState({ isLoading: false });
                    });
            }
        },
            (err) => {
                handleErrorToast(`
        An error occurred.
        Start a new tab and leave this page open.
        A support representative will reach out to you soon.`);
                s.setState({ isLoading: false });
            },
        );
}


// tslint:disable-next-line: max-line-length
export function handleAnswerUpdate(value: string, validator: validatorFn, index: number, dispatch: React.Dispatch<Action>, portalType: PortalType): void {
    dispatch({ type: "handle answer update", index, value, validator });

    clearTimeout(timeouts[index]);
    timeouts[index] = window.setTimeout(() => {
        dispatch({ type: "handle answer validation", index });
    }, getDelayLength(portalType, index));
}

// tslint:disable-next-line: max-line-length
export function handleErrorToast(description: string): void {
  // if timeout is clear,
  if (timeouts[15] === 0) {
    // show error toast
    toast({
      description,
      icon: "alarm",
      size: "mini",
      time: 5000,
      title: "Error",
      type: "error",
    });
    // set new timeout
    timeouts[15] = window.setTimeout(() => {
      timeouts[15] = 0; // clear when toast clears
    }, 50000);
  }
}

export function getDelayLength(type: PortalType, i: number) {
    if (type === PortalType.Underwriting || type == PortalType.ExperienceRating) {
        return (i === 6 || i === 7) ? 1 : 950;
    } else if (type === PortalType.SingleEntityOwnership) {
        return (i === 7 || i === 8 || i === 12) ? 1 : 950;
    } else if (type === PortalType.PolicyCoverage || type == PortalType.NoticeOfElection
        || type === PortalType.Plan || type === PortalType.Actuarial || type == PortalType.Membership ||
        PortalType.SpecialCalls) {
        return 950;
    }
}

function handleQuestionSetSelection(value: string, s: State): State {
    let portalType = PortalType.None;
    let portalState: { questionAnswerState: QAPropsBase[] } | null = null;

    if (value === "Class Inquiry" || value === "Audit Inquiry") {
        portalType = PortalType.Underwriting;
        portalState = UNDERWRITING_INITIAL_STATE;
    } else if (value === "Single Entity Ownership Submission") {
        portalType = PortalType.SingleEntityOwnership;
        portalState = OWNERSHIP_INITIAL_STATE;
    } else if (value === "Policy Coverage Request") {
        portalType = PortalType.PolicyCoverage
        portalState = COVERAGE_INITIAL_STATE;
    } else if (value === "Experience Rating Inquiry") {
        portalType = PortalType.ExperienceRating
        portalState = EXPERIENCE_RATING_INITIAL_STATE;
    } else if (value === "Notice Of Election") {
        portalType = PortalType.NoticeOfElection
        portalState = NOTICE_OF_ELECTION_INITIAL_STATE;
    } else if (value === "Actuarial Inquiry") {
        portalType = PortalType.Actuarial
        portalState = ACTUARIAL_INITIAL_STATE;
    } else if (value === "Membership Inquiry") {
        portalType = PortalType.Membership
        portalState = MEMBERSHIP_INITIAL_STATE;
    } else if (value === "Plan Correspondence Submission") {
        portalType = PortalType.Plan
        portalState = PLAN_INITIAL_STATE;
    } else if (value === "Special Calls Submission") {
        portalType = PortalType.SpecialCalls
        portalState = SPECIAL_CALLS_INITIAL_STATE;
    } else {
        portalState = HOME_INITIAL_STATE;
    }

    return {
        appState: { ...s.appState, isNavbarVisible: portalType != PortalType.None, optionChosen: portalType, dropDownOption: portalType != PortalType.None ? value : "" },
        answerState: portalState == null ? portalState : [ ...portalState.questionAnswerState ]
    };
}

function setUnderwritingState(n: number, s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.Underwriting, isNavbarVisible: true, inquiryType: n },
        answerState: [ ...UNDERWRITING_INITIAL_STATE.questionAnswerState ],
    };
}

function setOwnershipState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.SingleEntityOwnership, isNavbarVisible: true },
        answerState: [ ...OWNERSHIP_INITIAL_STATE.questionAnswerState ],
    };
}

function setPolicyCoverageState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.PolicyCoverage, isNavbarVisible: true },
        answerState: [ ...COVERAGE_INITIAL_STATE.questionAnswerState ],
    };
}

function setExperienceRatingState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.ExperienceRating, isNavbarVisible: true },
        answerState: [ ...EXPERIENCE_RATING_INITIAL_STATE.questionAnswerState ],
    };
}

function setNoticeOfElectionState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.NoticeOfElection, isNavbarVisible: true },
        answerState: [ ...NOTICE_OF_ELECTION_INITIAL_STATE.questionAnswerState ],
    };
}

function setPlanState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.Plan, isNavbarVisible: true },
        answerState: [ ...PLAN_INITIAL_STATE.questionAnswerState ],
    };
}

function setSpecialCallsState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.SpecialCalls, isNavbarVisible: true },
        answerState: [...SPECIAL_CALLS_INITIAL_STATE.questionAnswerState],
    };
}

function setActuarialState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.Actuarial, isNavbarVisible: true },
        answerState: [ ...ACTUARIAL_INITIAL_STATE.questionAnswerState ],
    };
}

function setMembershipState(s: State): State {
    return {
        appState: { ...s.appState, optionChosen: PortalType.Membership, isNavbarVisible: true },
        answerState: [ ...MEMBERSHIP_INITIAL_STATE.questionAnswerState ],
    };
}

function toggleTheme(s: State): State {
  return {
        appState: { ...s.appState, isDarkTheme: !s.appState.isDarkTheme },
        answerState: s.answerState == null ? null : [ ...s.answerState ],
  };
}

function setSignIn(s: State, user?: User): State {
    return {
        appState: { ...s.appState, user: user },
        answerState: s.answerState == null ? null : [ ...s.answerState ],
    };
}

function clearState(s: State): State {
    return {
        appState: { ...GLOBAL_INITIAL_STATE.appState, user: s.appState.user },
        answerState: null,
    };
}

function handleQAStateValidation(source: QAPropsBase[], index: number): QAPropsBase[] {
    return source.map((q, idx) => {
        if (idx === index) {
            q.showError = q.isAnswered && !q.isAnswerValid;
        }
        return q;
    });
}

function handleUpdate(s: State,
                      index: number,
                      value: string,
                      validator?: validatorFn): State {
        return {
            appState: { ...s.appState },
            answerState: s.answerState == null ? null :
                handleQAStateUpdate(s.answerState, index, value, validator ? validator :
                    getValidator(s.answerState[index].answerType, s.answerState[index].answerContent)),
        };
}

function handleValidation(index: number, s: State): State {
    return {
        appState: { ...s.appState },
        answerState: s.answerState == null ? null : handleQAStateValidation(s.answerState, index),
    };
}

function checkAuth(s: State): State {
    if (!s.appState.user && (s.appState.optionChosen === PortalType.Plan || s.appState.optionChosen === PortalType.SpecialCalls)) {
        signInRedirectS(s.appState.dropDownOption);
    }

    return {
        appState: { ...s.appState },
        answerState: s.answerState == null ? null : [...s.answerState]
    }
}

const StateProvider: React.FunctionComponent<Props> = (props: Props) => {
  const [state, dispatch] = useReducer<React.Reducer<State, Action>>((s: State, action: Action) => {
    switch (action.type) {
      case "set underwriting":
          return setUnderwritingState(action.value as number, s);
        case "unset admin status":
            return setSignIn(s, action.value as User);
        case "set admin status":
            return setSignIn(s, action.value as User);
      case "set ownership":
          return setOwnershipState(s);
      case "set policyCoverage":
          return setPolicyCoverageState(s);
      case "set experienceRating":
          return setExperienceRatingState(s);
      case "set noticeOfElection":
          return setNoticeOfElectionState(s);
        case "set plan":
            return setPlanState(s);
        case "set actuarial":
            return setActuarialState(s);
        case "set membership":
            return setMembershipState(s);
        case "set specialCalls":
            return setSpecialCallsState(s);
      case "toggle theme":
          return toggleTheme(s);
      case "clear state":
          return clearState(s);
      case "set questionnaire":
          return handleQuestionSetSelection(action.value as string, s);
      case "check authentication":
          return checkAuth(s);
        case "handle answer update":
           return handleUpdate(s, action.index as number, action.value as string, action.validator);
        case "handle answer validation":
          return handleValidation(action.index as number, s);
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{props.children}</Provider>;
};

export { store, StateProvider };

function getValidator(answerType: string, answerContent: string): validatorFn {
    switch (answerType) {
        case "text":
            return stringValidatorN(0, 1000);
            break;
        case "tel":
            return (s) => phoneValidator(s);
            break;
        case "number":
            return (s) => numberValidator(s);
            break;
        case "email":
            return (s) => emailValidator(s);
            break;
        case "date":
            return (s) => dateValidator(s);
            break;
        case "file":
            return (s) => fileValidator(s);
            break;
        case "conditional-file":
            return (s) => conditionalFileValidator(s);
            break;
        case "ownership-table":
            return (s) => ownershipValidator(s);
            break;
        case "date-table":
            return (s) => datesValidator(s);
            break;
        case "names-locations-table":
            return (s) => nameLocsValidator(s);
            break;
        case "pcov-table":
        case "pcov-table-ex":
            return (s) => pcovValidator(s);
            break;
        case "TextArea":
            return stringValidatorN(0, 2147483648);
            break;
        case "Radio":
            return stringValidatorN(0);
            break;
        case "Checkbox":
            return (s) => s ? true : false;
            break;
        case "DropDown":
            return numberValidatorN(answerContent.split(';').length - 1);
            break;
        default:
            throw new Error(`No Validator found for type ${answerType}`);
    }
}

function formAppendHandler(formData: FormData, answerType: string, propName: string, answerValue: any) {
    if (propName !== "N/A") {
        switch (answerType) {
            case "text":
            case "tel":
            case "number":
            case "email":
            case "date":
            case "TextArea":
            case "Radio":
            case "Checkbox":
            case "DropDown":
                formData.append(propName, (answerValue as string).replace("'", ""));
                break;
            case "file":
                formData.append(propName.length === 0 ? "Files" : propName, "");
                if (answerValue != null && answerValue.length > 0) {
                    for (let x = 0; x < answerValue.length; x++) {
                        const y = answerValue.item(x);
                        if (y != null) {
                            formData.append("file" + x, y);
                        }
                    }
                }
                break;
            case "conditional-file":
                formData.append(propName.length === 0 ? "Files" : propName, "");
                if ((answerValue as ConditionalFileProps).files != null
                    && (answerValue as ConditionalFileProps).files!.length > 0) {
                    for (let x = 0; x < (answerValue as ConditionalFileProps).files!.length; x++) {
                        const y = (answerValue as ConditionalFileProps).files!.item(x);
                        if (y != null) {
                            formData.append("file" + x, y);
                        }
                    }
                }
                break;
            case "ownership-table":
            case "date-table":
            case "names-locations-table":
                formData.append(propName, JSON.stringify(answerValue));
                break;
            case "pcov-table":
            case "pcov-table-ex":
                formData.append("CoverageEffDate", (answerValue as CoverageProps).policyEffectiveDate);
                formData.append(propName.length === 0 ? "EntityName" : propName, (answerValue as CoverageProps).entityName);
                formData.append("CoverageId", (answerValue as CoverageProps).entityID);
                break;
            default:
                throw new Error(`No Validator found for type ${answerType}`);
        }
    }
}
